// Libraries
import { Stack } from "@mui/material";
import { ConfirmCancelButtons } from "@smartrr/shared/customerPortal/components/ConfirmCancelButtons";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { localize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React, { useRef } from "react";
import { toast } from "react-toastify";

// Components

import { unpauseSubscription } from "@customer-app/state/actionCreators/customerPurchaseStates";
import { useCloseModal } from "@customer-app/state/actionCreators/modal";
import {
  useSmartrrCustomerDispatch,
  useSmartrrCustomerSelector,
} from "@customer-app/state/typedCustomerReduxHooks";

import { CenterText } from "./CenterText";

interface IResumeViewProps {
  setIconButtonInactive: () => void;
  purchaseState: IPurchaseState;
}

export const ResumeView = ({ purchaseState, setIconButtonInactive, ...props }: IResumeViewProps): JSX.Element => {
  const dispatch = useSmartrrCustomerDispatch();
  const closeModal = useCloseModal();
  const isPauseLoading = useSmartrrCustomerSelector(state => state.purchaseStates.isPauseLoading);
  const localizeShorthand = "subscriptions.yourSubscriptions.manageSubscriptionModal";

  const stackRef = useRef<HTMLDivElement>(null);

  const onResume = async () => {
    await dispatch(unpauseSubscription(purchaseState.id))
      .then(res => {
        if (res.type === "PURCHASE_STATE_UNPAUSE_ERROR") {
          toast.error(localize(`${localizeShorthand}.pauseView.unpauseErrorToast`));
        } else if (res.type === "PURCHASE_STATE_UNPAUSE_SUCCESS") {
          toast(localize(`${localizeShorthand}.pauseView.unpauseToast`));
        }
      })
      .finally(() => closeModal());
  };

  return (
    <Stack ref={stackRef} spacing="15px" justifyContent="center" alignItems="center" sx={{ marginTop: "15px" }}>
      <CenterText title={localize(`${localizeShorthand}.pauseView.unpauseTitle`)}>
        {localize(`${localizeShorthand}.pauseView.unpauseBody`)}
      </CenterText>
      <ConfirmCancelButtons isLoading={isPauseLoading} onCancel={setIconButtonInactive} onConfirm={onResume} />
    </Stack>
  );
};
